import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AlienLogo } from "@/components/AlienLogo";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md border border-white/10 bg-[color:var(--bg-panel)] p-8 md:p-10">
        <div className="flex items-center gap-3 mb-8">
          <AlienLogo size={44} />
          <div>
            <p className="text-[color:var(--alien)] uppercase text-xs tracking-widest">Area riservata</p>
            <h1 className="font-display text-3xl">ADMIN LOGIN</h1>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="text-white/60 uppercase text-xs tracking-widest">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full mt-2 bg-transparent border border-white/20 px-4 py-3 text-white focus:border-[color:var(--alien)] outline-none"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-white/60 uppercase text-xs tracking-widest">Password</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full mt-2 bg-transparent border border-white/20 px-4 py-3 text-white focus:border-[color:var(--alien)] outline-none"
              autoComplete="current-password"
            />
          </div>
          {err && <p className="text-red-400 text-sm" data-testid="admin-login-error">{err}</p>}
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[color:var(--alien)] text-black font-bold py-3 uppercase tracking-widest text-sm hover:bg-[color:var(--alien-hover)] disabled:opacity-50"
          >
            {loading ? "Verifica..." : "Entra"}
          </button>
        </form>

        <a href="/" className="mt-6 block text-center text-white/40 hover:text-white/70 text-xs uppercase tracking-widest">← Torna al sito</a>
      </div>
    </div>
  );
}
